import { createRoot } from 'react-dom/client';
import ReactDOMServer from 'react-dom/server';
import Page from './page';
import LightboxActions from '../_flux/actions/lightbox_actions';
import {
  postcodeValidAction,
  postcodeInvalidAction,
  applyPostcodeAction,
  updatePostcodeAction,
} from '../_flux/actions/postcode_actions';
import { setPostcodeV2 } from '../_flux/helper/requests/set_postcode_v2';
import { removeStations } from '../_flux/actions/fitting_station_actions/remove_stations';
import MapActions from '../_flux/actions/map_actions';
import StationsActions from '../_flux/actions/fitting_station_actions';
import CartPage from '../_pages/cart_page.js';
import ActiveStationActions from '../_flux/actions/active_station_actions';
import MapStore from '../_flux/stores/map_store';
import ActiveStationStore from '../_flux/stores/active_station_store';
import { validatePostcode, showAutoCompletePostcodeSelector } from '../validator/PostcodeAutocompleteValidator';
import FittingStationFinderConstants from '../_flux/constants/fitting_station_finder_constants';
import prepareInitialStation from '../_flux/helper/initial_state_setup/fitting_station';
import { renderFittingStationFinder } from '../_flux/components/fitting_station_finder/fitting_station_finder';
import productReviews from '../_modules/product_reviews/product_reviews';
import Carousel from '../utilities/carousel';
import { setSkuAction, setTypeAction, showAction as showNotifyMeAction } from '../_flux/actions/notify_me_actions';
import { NotificationTypes } from '../_flux/constants/notify_me/notification_types';
import { init as initWheelAlignmentInfoLightBox } from '../_views/wheel_alignment_info_light_box/wheel_alignment_info_light_box_view';
import { init as initFSRemoveLightBox, onClose as fSRemoveLightBoxClose } from '../_views/fs_remove_light_box/fs_remove_light_box_view';
import { init as initCrossSellRemoveLightBox, onClose as crossSellRemoveLightBoxClose } from '../_views/cross_sell_remove_light_box/cross_sell_remove_light_box_view';
import { init as initCrossSellLightBox, onClose as crossSellLightBoxClose } from '../_views/cross_sell_light_box/cross_sell_light_box_view';
import FittingStationStore from '../_flux/stores/fitting_station_store';
import { addAction, updateAction as updateProduct } from '../_flux/actions/products_actions';
import { addAction as addCrossSellProduct } from '../_flux/actions/cross_sell_products_actions.js';
import calculateSetPrice from '../_flux/helper/calculate_set_price';
import { ProductsStore } from '../_flux/stores/products_store';
import { init as initSidebar } from '../_views/sidebar/pdp';
import { types } from '../_constants/product/types';
import { init as initNotifyMe } from '../_views/notify_me/notify_me';
import { init as initFriendbuyBoxView } from '../_views/friendbuy_light_box/friendbuy_light_box';
import { init as initFSFMmotoLightBoxView } from '../_views/fsf_moto_light_box/fsf_moto_light_box_view';
import { init as initFSFNotAvailableLightBoxView } from '../_views/fsf_not_available_light_box/fsf_not_available_light_box_view';
import { allowVehicleConfiguratorOnStore } from '../_views/vehicle_configurator/show_on_store';
import { init as initCatalogConfigurator } from '../_views/configurator/catalog_configurator';
import { init as initRegoLookup } from '../_views/rego_lookup/rego_lookup';
import { init as initInfoPopup } from '../_views/info_popup/info_popup_view';
import { InfoPopupContainer } from '../_constants/info_popup';
import { init as initUiLock } from '../_views/ui_lock/ui_lock_view';
import { hideQuantityAndPriceRow } from '../_flux/actions/sidebar/pdp';
import { updateFilterOptionsAction } from '../_flux/actions/filter_options_actions';
import { getColor, isContainerLoadedInDOM, mapValues } from '../../lib/utilities';
import { formatFilterDefaultLabel } from '../_modules/filter/format_filter_default_label';
import { replaceWithOptionalFilterLabelTranslation } from '../_modules/translation/replace_with_optional_filter_label_translation';
import { getDefaultLabelFormattingConfig } from './catalog/set_initial_state';
import { FsfPages } from '../_constants/fsf_pages';
import { showAction as lockUi, hideAction as unlockUi } from '../_flux/actions/ui_lock_actions';
import { unsetActiveStationAction } from '../_flux/actions/active_station_actions';
import productBatchStocksRequest from '../_flux/components/product/product_batch_stocks_request';
import CatalogContainersConstants from './catalog/initialize_page_modules/catalog_container_constants';
import { init as initProductMixedStocksApp } from '../_views/product_mixed_stocks/product_mixed_stocks';
import { init as initMoreTyreAvailableLink } from '../_views/pdp/more_available_tyre_link';
import GooglePlaces from '../addressify/google/google_places';
import loadQualieTestimonials from '../utilities/qualie';
import initializeTargetComponent, { initializeConfiguratorComponents } from '../_views/initialize_component';
import { initializeLinkListSliderSections } from './landing_page/initialize_link_list_slider_sections';
import { initializeSlider } from './landing_page/initialize_slider';
import {
  onOpenRegoLookupClick,
  onOpenVehicleConfiguratorClick,
  onOpenExtendedCmsSizeConfiguratorClick,
  onOpenTyreSizeConfiguratorClick,
} from '../_views/configurator_buttons/configurator_buttons';
import { types as productTypes } from '../_constants/product/types';
import scrollToDetails from '../_modules/product/scroll_to_details';
import { init as initClearanceInfoLightBox } from '../_views/clearance_info_light_box/clearance_info_light_box';
import bindBadgesEvent from '../_flux/helper/clearance_info_click_event';
import { init as initFreeMobileFittingLightbox } from '../_views/free_mobile_fitting_light_box/free_mobile_fitting_light_box';
import API from '../API/api';
import PostcodeStore from '../_flux/stores/postcode_store';
import { getPostcodeFromLocalStorage } from '../utilities/local_storage';
import UsageDescription from '../_flux/components/fitting_station_finder/usage_description/usage_description';
import { initCmsLightboxContainer } from './landing_page/initialize_lightbox';
import { fsRemoveInvalidAction } from '../_flux/actions/fs_remove_light_box_actions';
import { hideAction as crossSellHide, crossSellRemoveInvalidAction } from '../_flux/actions/cross_sell_remove_light_box_actions';
import * as ProductDetailAccordionGoogleAnalytics from '../_modules/google_analytics/product/product_detail_accordion';
import setGeoLocation from '../utilities/geoLocation';
import { removeWheelAlignment } from '../_flux/helper/requests/wheel_alignment';
import { init as initImageLightBox, onClose as imageLightBoxClose } from '../_views/image_light_box/image_light_box_view';
import { showAction as showImageAction } from '../_flux/actions/image_light_box_actions';
import ImageZoom from '../utilities/image_zoom';
import { loadGoogleMapDependencies } from '../_global/initGoogleMapDependencies.js';
import {
  init as initVoucherCodeLightBox,
  onClose as voucherCodeLightBoxClose,
} from '../_views/voucher_code_light_box/voucher_code_light_box_view';
import CheckoutAddressPage from './checkout_address_page.js';
import { addLoadingAction, invalidAction, removeLoadingAction, update as updateVoucher, validAction } from '../_flux/actions/voucher_code_light_box_actions.js';
import { redeemProductVoucher } from '../_flux/helper/requests/redeem_product_voucher.js';

const ERROR_MESSAGE_VISIBLE_CLASSNAME = 'has-validation-error';

class ProductPage extends Page {
  static _name = 'ProductPage';

  constructor($container, flashMessages) {
    super($container, flashMessages);

    this.$shippingCost = $container.find('.shipping-caclulator__cost-incl-tax');
    this.$recommendations = $('.carousel__container');
  }

  /**
   * Init page
   */
  init() {
    super.init();

    setGeoLocation('pdp');
    if (this.$container.length) {
      this.removeExtraProductContent();
      this.initProductZoom();
      this.initOutOfStockHandler();
      this.initCarousel();
      this.initThumbnails();
      this.initFittingStation();
      this.initPostcode();
      this.initReactComponents();
      this.initContentToggles();
      this.initProductBatchStocks();
      this.bindOnSelectChangeTyreSize();
      this.initUsageDescription();
      initCmsLightboxContainer();
      initializeLinkListSliderSections();
      initializeSlider();
      productReviews(this.$container);
      scrollToDetails(this.$container);
      loadQualieTestimonials();

      const staticUrl = TYROOLA.globals.staticUrl;
      $('#init-vehicle-configurator, #init-rego-lookup').on('click', (e) => {
        this.initConfigurator(staticUrl, e);
      });

      initializeTargetComponent(
        'a[href*="#open-configurator"]',
        initializeConfiguratorComponents.bind(this, { productType: 'tyre', staticUrl }, true),
        onOpenTyreSizeConfiguratorClick,
        onOpenExtendedCmsSizeConfiguratorClick.bind(this, productTypes.TYRE_CAR)
      );

      initInfoPopup(document.getElementById(InfoPopupContainer), {});
      initClearanceInfoLightBox(document.getElementById('clearance-info'));
      initFreeMobileFittingLightbox(document.getElementById('free-mobile-fitting-light-box'), {
        baseUrl: TYROOLA.globals.baseUrl,
      });
      bindBadgesEvent();
      
      initVoucherCodeLightBox(document.getElementById('voucher-code'), {
        onRedeem: ProductPage.onRedeemPDP.bind(this),
      });
      // this.optimizeProductPriceQtySelect();
    }

    return this;
  }

  static async onRedeemPDP(voucherData, checkValidity) {
    try {
      lockUi();
      addLoadingAction();
      const res = await redeemProductVoucher(voucherData, checkValidity);
      validAction(res.success.userMessage);
      TYROOLA.initialFluxStates.voucherData = res.cart;
      updateVoucher({
        ...voucherData,
        idVouchers: res.cart && res.cart.allDiscounts ? res.cart.allDiscounts.map((d) => d.idVoucher) : [],
      });
      updateProduct({ id: voucherData.id });

      unlockUi();
      removeLoadingAction();
    } catch (e) {
      const error = e?.responseJSON?.userMessage || '';
      console.log(error);
      invalidAction(error);
      unlockUi();
      removeLoadingAction();
    }
  }

  optimizeProductPriceQtySelect() {
    const pdpTyreSizeSelect = $('#pdpTyreSizeSelect');
    const pdpTyreSizeSelectOptions = $('#pdpTyreSizeSelect').html();
    const selectedPdpTyreSizeSelect = $('#pdpTyreSizeSelect option[selected=selected]');

    pdpTyreSizeSelect.on('click', () => {
      if (pdpTyreSizeSelect.find('option').length <= 1) {
        pdpTyreSizeSelect.html(pdpTyreSizeSelectOptions);
      }
    });

    if (selectedPdpTyreSizeSelect.text()) {
      pdpTyreSizeSelect.html(selectedPdpTyreSizeSelect)
    } else {
      pdpTyreSizeSelect.html(pdpTyreSizeSelect.find('option')[0])
    }

  }

  initConfigurator(staticUrl, e) {
    initCatalogConfigurator(document.getElementById('configurator'), { productType: 'tyre', staticUrl });
    if (allowVehicleConfiguratorOnStore(TYROOLA.globals.store)) {
      const options = { productType: 'tyre', staticUrl };
      initializeTargetComponent(
        'a[href*="#open-vehicle-configurator"]',
        initializeConfiguratorComponents.bind(this, options),
        onOpenVehicleConfiguratorClick
      );
      initializeTargetComponent(
        'a[href*="#open-rego-lookup"]',
        initializeConfiguratorComponents.bind(this, options),
        onOpenRegoLookupClick
      );
      // initVehicleConfigurator(document.getElementById('vehicle-configurator'), { 'productType': 'tyre', staticUrl });
      // initRegoLookup(document.getElementById('rego-lookup-configurator'), { 'productType': 'tyre', staticUrl });
    }

    e.currentTarget.click();
  }

  bindOnSelectChangeTyreSize() {
    const tyreSizes = document.querySelector('#pdpTyreSizeSelect');
    if (tyreSizes) {
      tyreSizes.addEventListener('change', (evt) => {
        window.location.href = evt.target.value;
      });
    }
  }

  initProductBatchStocks() {
    const product = TYROOLA.initialFluxStates.product;
    if (['AU', 'AU_SCA', 'AU_NRMA', 'NZ', 'NZ_SCA'].indexOf(TYROOLA.globals.store) < 0) {
      return this;
    }

    if (product.stock < 5) {
      product.sku = product.id;
      productBatchStocksRequest(this.getProductType(), [product]).then((batchStocks) => {
        let batchStock = null;
        batchStocks.map((item) => {
          if (item.id.value !== product.sku) return null;
          batchStock = item;
        });

        if (batchStock) {
          const availableMixedQuantity = batchStock.body.mixedStocksAvailableQuantity;
          if (availableMixedQuantity > 0 && availableMixedQuantity > product.stock) {
            TYROOLA.mapsInitiated.then(() => {
              this.initGooglePlace();
            });
            loadGoogleMapDependencies(true);

            const options = {
              sku: product.sku,
              batchStock: batchStock,
              price: product.price,
              stock: product.stock,
              product: product,
              currencyIsoCode: TYROOLA.globals.currencyIsoCode,
            };
            initMoreTyreAvailableLink(document.getElementById('more-available-tyre'), options);
          }
        }
      });
    }

    return this;
  }

  initGooglePlace() {
    window.googlePlace = new GooglePlaces({ country: TYROOLA.globals.countryMainStore });
    return this;
  }

  removeExtraProductContent() {
    const currWidth = window.innerWidth;
    if (currWidth > 767) {
      let accordionElemMobile = document.querySelector('#accordionElemMobile');
      if (accordionElemMobile) {
        accordionElemMobile.innerHTML = '';
      }
    }
  }

  initProductZoom() {
    if ($(window).width() >= 768) {
      var target = document.querySelector('#zoom__element');

      this.imageZoom = new ImageZoom($('.description__zoom-container'), { min_width: 300 });

      this.imageZoom.init({
        target: target,
      });
    }
    $('.description__zoom-container').on('click', () => {
      const url = $('.description__zoom-container img').attr('src');
      const logo = $('.product-brand-logo').html();
      const title = `<div>
        <div>${logo}</div>
        <div>${$('.product__headline').text()}</div>
      </div>`;
      showImageAction({ url, title });
    });
  }

  /**
   * Initialise recommendations carousel
   * @returns {ProductPage}
   */
  initCarousel() {
    if (this.$recommendations.length) {
      this.carousel = new Carousel($('.carousel__container'));

      this.carousel.init({
        btnNext: '.carousel__control-next',
        btnPrev: '.carousel__control-prev',
      });
    }

    return this;
  }

  /**
   * @override
   * @return {Array}
   */
  getTrackerConfig() {
    return $.merge(Page.prototype.getTrackerConfig.call(this), [
      'AlternativeOrderTracker',
      'ProductRecommendationTracker',
    ]);
  }

  /**
   * @return {ProductPage}
   */
  initOutOfStockHandler() {
    const product = TYROOLA.initialFluxStates.product;
    const productSku = product.id;
    const notificationType = product.stock === 0 ? NotificationTypes.OUT_OF_STOCK : NotificationTypes.LOW_ON_STOCK;

    setSkuAction(productSku);
    setTypeAction(notificationType);
    $('.notify-me__a').on('click', showNotifyMeAction);

    initNotifyMe(document.getElementById('catalog-notify-me'));

    return this;
  }

  renderThumbnailDots() {
    let allThumbnails = document.querySelectorAll('.description__thumbnails:not(.lightbox-content-images) .thumb-3 img');
    const selectedImage = $('.description__zoom-container img').attr('src');

    if (allThumbnails) {
      allThumbnails = Array(...allThumbnails);
    }

    const thumbnailDotsContent = allThumbnails.map((thumbnail, key) => (<div
      src={(thumbnail.src || thumbnail.dataset['original'])}
      key={(thumbnail.src || thumbnail.dataset['original']) + key}
      className='thumbnail-dots'
      style={{ backgroundColor: ((thumbnail.src || thumbnail.dataset['original']) === selectedImage) ? getColor('mainColor') : 'rgba(0, 0, 0, 0.6)' }}
      onClick={(e) => this.onThumbnailDotClick(e, (thumbnail.src || thumbnail.dataset['original']))}
    ></div>));

    $('#thumbnail-dots-container').html(ReactDOMServer.renderToString(thumbnailDotsContent));
    $('.thumbnail-dots').on('click', $.proxy(this.onThumbnailDotClick, this));
  }

  onThumbnailDotClick(e) {
    const $target = $(e.target);
    let source = $target.attr('src');

    const childNumber = Array.prototype.indexOf.call(e.target.parentNode.children, e.target);
    const scrollElement = document.querySelector(`.description__thumbnails > div:nth-child(${childNumber + 1})`);

    scrollElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

    $('#description__thumbnail-target').attr('src', source);
    document.getElementById('zoom__element').innerHTML = '';
    this.initProductZoom();
    this.renderThumbnailDots();
  }

  initThumbnails() {
    this.renderThumbnailDots();

    $('.description__thumbnails img').on('click', $.proxy(this.handleThumbnail, this));
    return this;
  }

  handleThumbnail(e) {
    const $target = $(e.target);
    let source = $target.attr('src');

    e.currentTarget.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    if ($target.data('display-badge')) {
      $('[data-badge]').show();
    } else {
      $('[data-badge]').hide();
    }

    $('#description__thumbnail-target').attr('src', source);
    document.getElementById('zoom__element').innerHTML = '';
    this.initProductZoom();
    this.renderThumbnailDots();
  }

  /**
   * @returns {ProductPage}
   */
  initFittingStation() {
    TYROOLA.mapsInitiated.then(() => {
      var $infoBoxScript;
      $infoBoxScript = $('#info-box-script');
      $infoBoxScript.attr('src', $infoBoxScript.data('src'));
    });

    return this;
  }

  initReactComponents() {
    const pdpContextBox = document.querySelector('#pdp-sidebar');
    const productType = this.getProductType();
    const product = TYROOLA.initialFluxStates.product;
    const { crossSellProducts } = TYROOLA.initialFluxStates;

    addAction({
      ...product,
      crossSellProducts,
      setPrice: calculateSetPrice(product.qty, product.price, {
        buy4pay3: product.buy4pay3,
        off15: product.off15Perc,
        cashback100: product.cashback100,
      }),
    });

    initImageLightBox(document.querySelector('#preview-image'), {});
    if (!pdpContextBox) {
      return;
    }

    if (productType === types.TYRE_MOTO) {
      this.renderMotoFittingStationFinder();
    }
    if (productType === types.WHEEL) {
      this.renderWheelFittingStationFinder(productType);
    }

    if (productType === types.TYRE_CAR) {
      this.renderCarFittingStationFinder();
    }

    const { initialStation } = TYROOLA.initialFluxStates;
    if (initialStation && initialStation.id) {
      hideQuantityAndPriceRow();
    }

    TYROOLA.initialFluxStates.crossSellProducts.forEach(addCrossSellProduct);
    initSidebar(pdpContextBox, {
      productType: productType,
      currencyIsoCode: TYROOLA.globals.currencyIsoCode,
      baseUrl: TYROOLA.globals.baseUrl,
    });

    initWheelAlignmentInfoLightBox(document.getElementById('wheel-alignment-info'), {
      onRemove: ProductPage.onRemoveWheelAlignment.bind(this, 'product'),
    });

    initFSRemoveLightBox(document.getElementById('fs-remove'), {
      onRemove: ProductPage.onRemoveFittingStation,
    });

    initCrossSellLightBox(document.getElementById('cross-sell'), {});

    initFriendbuyBoxView(document.getElementById('wheel-alignment-info'), {
      staticUrl: TYROOLA.globals.staticUrl,
      baseUrl: TYROOLA.globals.baseUrl,
      storeUrl: TYROOLA.globals.storeUrl,
    });

    // ui lock when loading catalog
    const uiLockContainerElment = document.getElementById('ui-lock-container');
    initUiLock(uiLockContainerElment);

    updateFilterOptionsAction(
      Object.assign(
        {},
        mapValues(TYROOLA.initialFluxStates.filter.filterOptions, (filterOption, filterName) => {
          if (!Array.isArray(filterOption)) {
            return filterOption;
          }

          return filterOption.map((option) => {
            const [value, label] = option;
            const defaultLabelFormattingConfig = getDefaultLabelFormattingConfig(filterName);
            const defaultLabel = formatFilterDefaultLabel(label, defaultLabelFormattingConfig);
            const formattedLabel = replaceWithOptionalFilterLabelTranslation(value, defaultLabel);

            return [value, formattedLabel];
          });
        }),
        {}
      )
    );

    if (types.TYRE_CAR === this.getProductType()) {
      const productMixedStocksAppContainer = document.getElementById(
        CatalogContainersConstants.PRODUCT_MIXED_STOCKS_APP_CONTAINER_ID
      );
      initProductMixedStocksApp(productMixedStocksAppContainer, {});
    }
  }

  static async onRemoveWheelAlignment(type) {
    try {
      lockUi();
      await removeWheelAlignment();

      if (type === 'product' || type === 'cart') {
        CartPage.removeWheelAlignmentFromCart();
      } else {
        location.reload();
      }
      unlockUi();
    } catch (e) {
      console.log(e)
      unlockUi();
    }
  }

  static onRemoveFittingStation(fromCart) {
    lockUi();
    removeStations()
      .then(() => {
        unlockUi();
        unsetActiveStationAction();
        fSRemoveLightBoxClose();
        if (fromCart) {
          CartPage._setCartData();
        }
      })
      .catch((err) => {
        unlockUi();
        const responseJson = err?.responseJSON;
        fsRemoveInvalidAction(responseJson?.userMessage);
        StationsActions.handleFailedStations(null, responseJson);
      });
  }

  /**
   * @returns {string}
   */
  getProductType() {
    return TYROOLA.initialFluxStates.product.type;
  }

  async renderCarFittingStationFinder() {
    try {
      const request = await API.FETCH_GET(`/api/fittingstationfinderstate/`);
      const response = await request.json();
      const initialStation =
        response && response.initialStation && response.initialStation.id ? response.initialStation : null;

      if (initialStation && initialStation.wheelAlignment.wheels_2) {
        this._onWheels2Change(initialStation.id, true);
      }

      if (initialStation && initialStation.wheelAlignment.wheels_4) {
        this._onWheels4Change(initialStation.id, true);
      }

      prepareInitialStation(initialStation);

      if (initialStation) {
        const { id, qty } = TYROOLA.initialFluxStates.product;
        ActiveStationActions.fetchInitialStationAction({ id, qty });
      }

      renderFittingStationFinder({
        containerDOMNode: document.getElementById('fsf'),
        showSelectStationButton: true,
        showSuccessPage: true,
        showQuantityInput: true,
        showDisplayName: TYROOLA.globals.store === 'ID',
        onStationSelect: this._onStationSelect.bind(this),
        onWheels2Change: this._onWheels2Change.bind(this),
        onWheels4Change: this._onWheels4Change.bind(this),
      });
    } catch (e) {
      console.warn('something went wrong', e);
    }
  }

  renderMotoFittingStationFinder() {
    initFSFMmotoLightBoxView(document.getElementById('fsf-moto'));
  }

  renderWheelFittingStationFinder(productType) {
    initFSFNotAvailableLightBoxView(document.getElementById('fsf-moto'), { productType: productType });
  }

  /**
   * @returns {ProductPage}
   */
  initContentToggles() {
    const $toggleHeaders = $('.product-toggle__header');

    $toggleHeaders.on('click', function (e) {
      const $toggle = $(this).parent();

      if (!$toggle.hasClass('product-toggle--opened')) {
        // Call Google Analytics API
        ProductDetailAccordionGoogleAnalytics.clickOnAccordion(e.currentTarget.innerText);

        let $openedToggles = $('.product-toggle--opened');
        $openedToggles.each(function () {
          const openedToggle = $(this);
          const openedToggleContent = $openedToggles.find('.product-toggle__content');

          openedToggle.removeClass('product-toggle--opened');
          openedToggleContent.slideToggle();
        });
      }
      $('+ .product-toggle__content', this).slideToggle();
      $toggle.toggleClass('product-toggle--opened');
      Page.attachEuLabelsLightboxOnClick();
    });

    $('.product-toggle')
      .find('.default-opened')
      .each(function () {
        if ($(this).is(':visible')) {
          $(this).trigger('click');
        }
      });
    return this;
  }

  async _onStationSelect(newStation) {
    const activeStationStoreState = ActiveStationStore.getState();
    const wheelAlignment2 = activeStationStoreState.wheelAlignment.wheels2.indexOf(newStation.id) !== -1;
    const wheelAlignment4 = activeStationStoreState.wheelAlignment.wheels4.indexOf(newStation.id) !== -1;
    const product = TYROOLA.initialFluxStates.product;
    const isMpsOrder =
      newStation.hasOwnProperty('productStock') && newStation.productStock.hasOwnProperty('frontendPrice');
    const productId = isMpsOrder ? newStation.productStock.spinachId : product.id;
    await ActiveStationActions.setActiveStationAction(newStation, true, wheelAlignment2, wheelAlignment4);
    ActiveStationActions.addProductToCartAction(
      newStation,
      productId,
      isMpsOrder,
      true,
      wheelAlignment2,
      wheelAlignment4
    );

    hideQuantityAndPriceRow();
  }

  _onWheels2Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('2', stationId);
  }

  _onWheels4Change(stationId, isChecked) {
    const action = isChecked ? ActiveStationActions.setWheelAlignment : ActiveStationActions.unsetWheelAlignment;
    action('4', stationId);
  }

  static hideErrorMessage($error, $errorVisibleClassName) {
    $error.removeClass($errorVisibleClassName);
  }

  static showErrorMessage($error, $errorVisibleClassName) {
    $error.addClass($errorVisibleClassName);
  }

  initPostcode() {
    const postcode = showAutoCompletePostcodeSelector(TYROOLA.globals.store)
      ? getPostcodeFromLocalStorage() : $('.product-toggle .postcode-form__input').val();
    if (postcode) {
      applyPostcodeAction(postcode);
    }

    return this;
  }

  initUsageDescription() {
    const containers = document.querySelectorAll('#pdp-usage-description');
    containers.forEach(container => {
      if (container) {
        setTimeout(() => {
          if (!isContainerLoadedInDOM(container)) {
            TYROOLA.root[container.id] = createRoot(container);
          }
          return TYROOLA.root[container.id].render(<UsageDescription
            standAlone
            onPostcodeSubmit={this._onPostcodeFormSubmit}
            store={TYROOLA.globals.store}
            validateAutocompleteInput={this._postcodeValidation}
          />);
        });
      }
    });

    return this;
  }

  _postcodeValidation(postcode) {
    const { postcodeSuggestion, touched } = PostcodeStore.getState();
    return validatePostcode(TYROOLA.globals.store, postcode, postcodeSuggestion, touched);
  }

  _onPostcodeFormSubmit(inputVal) {
    const postCode = inputVal;
    const { postcodeSuggestion, touched } = PostcodeStore.getState();
    if (validatePostcode(TYROOLA.globals.store, postCode, postcodeSuggestion, touched)) {
      applyPostcodeAction(postCode);
      updatePostcodeAction(postCode);
      LightboxActions.totalPagesChangeAction(FsfPages.WITH_SUCCESS_NOTIFICATION);
      LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
      LightboxActions.openAction();
      StationsActions.startFetchingStationsAction();
      setPostcodeV2(postCode, true)
        .then(() => {
          postcodeValidAction();
          MapActions.updateLatLngAction(postCode).then(() => {
            const products = ProductsStore.getState();
            const product = products[0];
            const mapStoreState = MapStore.getState();
            StationsActions.fetchStationsAction(
              {
                postcode: postCode,
                latitude: mapStoreState.latLng.lat(),
                longitude: mapStoreState.latLng.lng(),
                qty: product.qty,
                id: product.id,
              },
              products
            );
          });
        })
        .catch((err) => {
          const responseJson = err?.responseJSON;
          postcodeInvalidAction(responseJson?.userMessage);
          StationsActions.handleFailedStations(null, responseJson);
        });
    } else {
      postcodeInvalidAction('something went wrong please try again');
    }

    return false;
  }
}

export default ProductPage;
export { ProductPage };
